import * as React from "react";
import { cn } from "@/lib/utils";

type ContainerProps = React.PropsWithChildren<{ className?: string }>;

export function Container({ children, className }: ContainerProps) {
  return (
    <div
      className={cn(
        "mx-auto w-full max-w-[1320px] px-4 sm:px-6 lg:px-8",
        className,
      )}
    >
      {children}
    </div>
  );
}
